import { render, staticRenderFns } from "./SendTestEmail.vue?vue&type=template&id=2bdf30ae"
import script from "./SendTestEmail.vue?vue&type=script&lang=ts"
export * from "./SendTestEmail.vue?vue&type=script&lang=ts"
import style0 from "./SendTestEmail.vue?vue&type=style&index=0&id=2bdf30ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports